import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [  
  {
    title: 'Note',
    field: 'note',
    filter: 'text',
    width: '550px',
    searchable: true,
  },
  {
    title: 'Note Type ',
    field: 'noteSection',
    filter: 'text',
    width: undefined,
    searchable: true,
  },
  // {
  //   title: 'Note Section',
  //   field: 'noteSection',
  //   filter: 'text',
  //   width: undefined,
  //   searchable: true,
  // },

  {
    title: 'Added By ',
    field: 'createdByFullName',
    filter: 'text',
    width: undefined,
    searchable: true,
  },

  {
    title: 'Created Date',
    field: 'createdOn',
    filter: 'date',
    width: undefined,
    searchable: true,
  },
];
